import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/cookie.scss";

const COOKIE_PREFERENCE_KEY = "anackmira_cookie_preferences_v1";

function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [preferences, setPreferences] = useState({ analytics: false });

  useEffect(() => {
    try {
      setVisible(!window.localStorage.getItem(COOKIE_PREFERENCE_KEY));
    } catch (error) {
      setVisible(true);
    }
  }, []);

  const savePreferences = (analytics) => {
    const value = {
      essential: true,
      analytics,
      savedAt: new Date().toISOString(),
    };
    try {
      window.localStorage.setItem(COOKIE_PREFERENCE_KEY, JSON.stringify(value));
    } catch (error) {
      console.warn("Could not save cookie preferences.", error);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <section className="cookie-banner" aria-label="Cookie preferences">
      <div className="cookie-banner__copy">
        <span className="cookie-banner__icon" aria-hidden="true">◌</span>
        <div>
          <p className="eyebrow">Your privacy</p>
          <h2>Choose how this site remembers you.</h2>
          <p>
            anackmira uses essential browser storage for your cart, saved games,
            progress and preferences. We do not currently use advertising cookies.
            Read our <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
      </div>

      {settingsOpen && (
        <div className="cookie-settings" id="cookie-settings">
          <div>
            <div><strong>Essential storage</strong><span>Always active</span></div>
            <p>Required for local cart, game progress and consent preferences.</p>
          </div>
          <label>
            <span><strong>Optional analytics</strong><small>Not currently in use</small></span>
            <input
              type="checkbox"
              checked={preferences.analytics}
              onChange={(event) => setPreferences({ analytics: event.target.checked })}
            />
          </label>
        </div>
      )}

      <div className="cookie-banner__actions">
        <button className="cookie-link" type="button" aria-expanded={settingsOpen} aria-controls="cookie-settings" onClick={() => setSettingsOpen((open) => !open)}>
          {settingsOpen ? "Hide settings" : "Manage settings"}
        </button>
        <button className="button button--quiet" type="button" onClick={() => savePreferences(false)}>Essential only</button>
        <button className="button" type="button" onClick={() => savePreferences(preferences.analytics || !settingsOpen)}>
          {settingsOpen ? "Save choices" : "Accept optional"}
        </button>
      </div>
    </section>
  );
}

export default CookieBanner;
